"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Loading = require("./Loading.styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// const useStyles = makeStyles((theme) =>
//   createStyles({
//     root: {
//       display: 'flex',
//       '& > * + *': {
//         marginLeft: theme.spacing(2)
//       },
//       position: 'absolute',
//       top: 0,
//       width: '100%',
//       height: '100%',
//       justifyContent: 'center',
//       alignItems: 'center'
//     }
//   })
// );

function CircularIndeterminate(_ref) {
  var visible = _ref.visible;
  // const classes = useStyles();

  return visible ? /*#__PURE__*/_react["default"].createElement(_Loading.DivStyled, null, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null)) : null;
}
CircularIndeterminate.propTypes = {
  visible: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = CircularIndeterminate;